import { useRef, useEffect } from "react";

type MonthsListProps = {
  months: string[];
  currentDate: Date;
  setCurrentDate: (date: Date) => void;
};

export const MonthsList: React.FC<MonthsListProps> = ({
  months,
  currentDate,
  setCurrentDate,
}) => {
  const currentMonthRef = useRef<HTMLButtonElement>(null);

  // Scroll to current month/year when component mounts
  useEffect(() => {
    if (currentMonthRef.current) {
      currentMonthRef.current.scrollIntoView({ block: "center" });
    }
  }, []);

  const handleSelectMonth = (month: number) => {
    setCurrentDate(
      new Date(
        Date.UTC(
          currentDate.getUTCFullYear(),
          month,
          1,
          currentDate.getUTCHours(),
          currentDate.getUTCMinutes()
        )
      )
    );
  };

  return (
    <div className="border-l pl-4 outline-quaternary">
      <div className="h-full flex flex-col w-max  custom-scrollbar overflow-y-auto">
        {months.map((month, index) => (
          <button
            key={month}
            ref={currentDate.getUTCMonth() === index ? currentMonthRef : null}
            onClick={() => handleSelectMonth(index)}
            className={` w-full p-2 text-left rounded-lg
                  ${
                    currentDate.getUTCMonth() === index
                      ? "cta-primary font-light-primary body-2-medium"
                      : "body-2-regular font-secondary hover:surface-secondary"
                  }
                `}
          >
            {month}
          </button>
        ))}
      </div>
    </div>
  );
};
